import React from "react";
import { motion } from "framer-motion";
import { Compass, MapPin, Home, Truck, GraduationCap, Briefcase } from "lucide-react";
import { T } from "@/context/LanguageContext";

export const INTENTS = [
  { id: "explore", label: "Exploring", icon: Compass },
  { id: "visit", label: "Visiting", icon: MapPin },
  { id: "live", label: "I Live Here", icon: Home },
  { id: "move", label: "Moving Here", icon: Truck },
  { id: "student", label: "Student", icon: GraduationCap },
  { id: "business", label: "Business", icon: Briefcase },
];

export function IntentSwitcher({ active, onChange }) {
  return (
    <div data-testid="intent-switcher">
      <div className="mb-2 text-xs font-bold uppercase tracking-widest text-muted-foreground"><T>What brings you here?</T></div>
      <div className="flex flex-wrap gap-2">
        {INTENTS.map((it) => {
          const Icon = it.icon;
          const on = active === it.id;
          return (
            <button key={it.id} onClick={() => onChange(it.id)}
              className={`relative inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition-colors ${on ? "text-white" : "border border-navy/15 bg-white text-navy hover:border-navy"}`}
              data-testid={`intent-tab-${it.id}`}>
              {on && (
                <motion.span layoutId="intent-pill" transition={{ type: "spring", stiffness: 400, damping: 32 }}
                  className="absolute inset-0 -z-0 rounded-full bg-navy" />
              )}
              <span className="relative z-10 flex items-center gap-2"><Icon className="h-4 w-4" /><T>{it.label}</T></span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
